<mat-toolbar class="sticky-top mat-elevation-z8 mt-3">
  <mat-toolbar-row>
    <button (click)="sidenav.toggle()" color="primary" class="side-nav-button" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <img *ngIf="logo" class="header-logo img-fluid pointer" [routerLink]="'/dashboard'" [src]="logo" alt="Logo" />
    <span class="first-nav-spacer"></span>
    <div class="header-nav-container">
      <button
        mat-button
        [routerLink]="'/dashboard'"
        color="primary"
        class="header-buttons mr-2"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Home
      </button>
      <button
        #buttonAccountManagement
        mat-button
        color="primary"
        class="header-buttons header-dropdown"
        [matMenuTriggerFor]="accountManagementMenu"
        #accountManagementMenuTrigger="matMenuTrigger"
        (mouseenter)="mouseEnter(accountManagementMenuTrigger, firstItemAccount)"
        (mouseleave)="mouseLeave(accountManagementMenuTrigger, buttonAccountManagement)"
        [ngStyle]="{
          'border-bottom': accountManagementMenuTrigger.menuOpen ? '3px solid black' : '3px solid transparent'
        }"
      >
        Account Management
        <mat-icon>{{ accountManagementMenuTrigger.menuOpen ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
      </button>
      <button
        #buttonSalesManagement
        mat-button
        color="primary"
        class="header-buttons header-dropdown"
        [matMenuTriggerFor]="salesManagementMenu"
        #salesManagementMenuTrigger="matMenuTrigger"
        (mouseenter)="mouseEnter(salesManagementMenuTrigger, firstItemSales)"
        (mouseleave)="mouseLeave(salesManagementMenuTrigger, buttonSalesManagement)"
        [ngStyle]="{
          'border-bottom': salesManagementMenuTrigger.menuOpen ? '3px solid black' : '3px solid transparent'
        }"
      >
        Sales Management
        <mat-icon>{{ salesManagementMenuTrigger.menuOpen ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
      </button>
      <button
        #buttonAssetManagement
        mat-button
        color="primary"
        class="header-buttons header-dropdown"
        [matMenuTriggerFor]="assetManagementMenu"
        #assetManagementMenuTrigger="matMenuTrigger"
        (mouseenter)="mouseEnter(assetManagementMenuTrigger, firstItemAsset)"
        (mouseleave)="mouseLeave(assetManagementMenuTrigger, buttonAssetManagement)"
        [ngStyle]="{
          'border-bottom': assetManagementMenuTrigger.menuOpen ? '3px solid black' : '3px solid transparent'
        }"
      >
        Asset Management
        <mat-icon>{{ assetManagementMenuTrigger.menuOpen ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
      </button>
      <button
        mat-button
        [routerLink]="'/reporting'"
        color="primary"
        class="header-buttons"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Reporting
      </button>
    </div>
    <span class="spacer"></span>
    <button mat-button (click)="addTicket()" color="primary" class="add-ticket-btn">+ Add Ticket</button>

    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" aria-label="Example icon-button with a menu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <div class="profile-menu">
        <button mat-menu-item (click)="myAccount()">
          <span>Edit Profile</span>
        </button>
        <button *ngIf="shouldShowSettings()" mat-menu-item (click)="toggleSettingsDropdown($event)">
          <span
            >Settings
            <mat-icon class="carat-icon">{{
              showSettingsDropdown ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</mat-icon>
          </span>
        </button>
        <div *ngIf="showSettingsDropdown" class="settings-sub-menu">
          <button *ngIf="shouldShowMaintenanceProvider()" mat-menu-item [routerLink]="'/maintenance-providers'">
            <span>Maintenance Providers</span>
          </button>
          <button mat-menu-item [routerLink]="'/internal-providers'">
            <span>Internal Providers</span>
          </button>
          <button mat-menu-item [routerLink]="'/configurable-options'">
            <span>Configurable Options</span>
          </button>
        </div>
        <button mat-menu-item (click)="logout()">
          <span>Log Out</span>
        </button>
      </div>
      <mat-divider></mat-divider>
      <div class="view-as-section" *ngIf="currentUser.viewAsSelector()">
        <app-view-as *ngIf="currentUser.viewAsSelector()"></app-view-as>
      </div>
    </mat-menu>

    <mat-menu #accountManagementMenu="matMenu" [hasBackdrop]="false">
      <div
        class="profile-menu header-dropdown"
        (mouseenter)="mouseEnter(accountManagementMenuTrigger)"
        (mouseleave)="mouseLeave(accountManagementMenuTrigger, buttonAccountManagement)"
      >
        <button mat-menu-item [routerLink]="'/partners'" #firstItemAccount [hidden]="!currentUser.hasType(['global'])">
          <span>Partners</span>
        </button>
        <button mat-menu-item [routerLink]="'/companies'" [hidden]="!currentUser.hasType(['global', 'partner'])">
          <span>Companies</span>
        </button>
        <button mat-menu-item [routerLink]="'/users'">
          <span>Users</span>
        </button>
        <button mat-menu-item [routerLink]="'/company-attachments'" [hidden]="!currentUser.isCompany()">
          <span>Company Attachments</span>
        </button>
      </div>
    </mat-menu>
    <mat-menu #salesManagementMenu="matMenu" [hasBackdrop]="false">
      <div
        class="profile-menu header-dropdown"
        (mouseenter)="mouseEnter(salesManagementMenuTrigger)"
        (mouseleave)="mouseLeave(salesManagementMenuTrigger, buttonSalesManagement)"
      >
        <button mat-menu-item [routerLink]="'/contracts'" #firstItemSales>
          <span>Contracts</span>
        </button>
        <button mat-menu-item [routerLink]="'/quotes'" [hidden]="!(showComponent('quotes') && currentUser.isGlobal())">
          <span>Quotes</span>
        </button>
      </div>
    </mat-menu>
    <mat-menu #assetManagementMenu="matMenu" [hasBackdrop]="false">
      <div
        class="profile-menu header-dropdown"
        (mouseenter)="mouseEnter(assetManagementMenuTrigger)"
        (mouseleave)="mouseLeave(assetManagementMenuTrigger, buttonAssetManagement)"
      >
        <button mat-menu-item [routerLink]="'/assets'" #firstItemAsset>
          <span>Assets</span>
        </button>
        <button mat-menu-item [routerLink]="'/locations'">
          <span>Locations</span>
        </button>
        <button mat-menu-item [routerLink]="'/tickets'">
          <span>Tickets</span>
        </button>
      </div>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container>
  <mat-sidenav class="side-menu" #sidenav>
    <mat-nav-list>
      <a mat-list-item [routerLink]="'/dashboard'" (click)="sidenav.close()">
        <mat-icon color="primary">home</mat-icon> &nbsp;&nbsp; Dashboard
      </a>
      <a *ngIf="currentUser.hasType(['global'])" mat-list-item>
        <mat-icon color="primary">group_work</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/partners'" (click)="sidenav.close()">Partners</a>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="addPartner(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a *ngIf="currentUser.hasType(['global', 'partner'])" mat-list-item>
        <mat-icon color="primary">business</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/companies'" (click)="sidenav.close()">Companies</a>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="addCompany(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">location_on</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/locations'" (click)="sidenav.close()">Locations</a>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="addLocation(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">description</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/contracts'" (click)="sidenav.close()">Contracts</a>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="addContract(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a *ngIf="showComponent('quotes') && currentUser.isGlobal()" mat-list-item>
        <mat-icon color="primary">description</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/quotes'" (click)="sidenav.close()">Quotes</a>
        <button
          *ngIf="currentUser.isGlobal() && currentUser.hasRight(['admin'])"
          (click)="addQuote(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">view_list</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/assets'" (click)="sidenav.close()">Assets</a>
        <button
          *ngIf="currentUser.hasRight(['admin', 'manager'])"
          (click)="addAsset(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">bug_report</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/tickets'" (click)="sidenav.close()">Tickets</a>
        <button (click)="addTicket(); sidenav.close()" align="end" color="primary" mat-icon-button>
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a *ngIf="currentUser.isGlobal()" mat-list-item>
        <mat-icon color="primary">grading</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/internal-providers'" (click)="sidenav.close()">Internal Providers</a>
        <button
          *ngIf="currentUser.hasRight(['admin'])"
          (click)="addInternalProvider(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a *ngIf="shouldShowMaintenanceProvider()" mat-list-item>
        <mat-icon color="primary">grading</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/maintenance-providers'" (click)="sidenav.close()">Maintenance Providers</a>
        <button
          *ngIf="currentUser.hasRight(['admin'])"
          (click)="addMaintenanceProvider(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a *ngIf="currentUser.isCompany()" mat-list-item>
        <mat-icon color="primary">work</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/company-attachments'" (click)="sidenav.close()">Company Attachments</a>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">group</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/users'" (click)="sidenav.close()">Users</a>
        <button
          *ngIf="currentUser.canCreateUser()"
          (click)="addUser(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
      <a mat-list-item>
        <mat-icon color="primary">poll</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/reporting'" (click)="sidenav.close()">Reporting</a>
      </a>
      <a *ngIf="currentUser.isGlobal()" mat-list-item>
        <mat-icon color="primary">list_alt</mat-icon>&nbsp;&nbsp;
        <a [routerLink]="'/configurable-options'" (click)="sidenav.close()">Configurable Options</a>
        <button
          *ngIf="currentUser.isGlobalAdmin()"
          (click)="addConfigurableOption(); sidenav.close()"
          align="end"
          color="primary"
          mat-icon-button
        >
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<div class="loading-indicator" *ngIf="loading$ | async">
  <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
</div>
